<template>
  <b-container>
    <b-form v-on:submit.prevent>
      <b-row>
        <b-col cols="8">
          <b-card>
            <b-row>
              <b-col class="mb-2">
                <b-badge :variant="statusVariant(form.status)">
                  <span v-if="form.status === 1">{{ form.status_name }}</span>
                  <span v-else-if="form.status === 2">{{
                    form.status_name
                  }}</span>
                </b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Item" label-for="asset_item">
                  <v-select
                    id="asset_item"
                    v-model="form.selectedItem"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsItem"
                    placeholder="Select 1 Item"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedItem"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedItem }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Location" label-for="Location">
                  <v-select
                    id="Location"
                    v-model="form.selectedLocation"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsLocation"
                    placeholder="Select 1 Location"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedLocation"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedLocation }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Condition" label-for="condition">
                  <v-select
                    id="condition"
                    v-model="form.selectedCondition"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsCondition"
                    placeholder="Select 1 Condition"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedCondition"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedCondition }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    required
                    :disabled="form.status === 1 ? false : true"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.status === 1">
              <!-- submit and reset -->
              <b-col md="12" class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  block
                  @click="validation()"
                >
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card>
            <b-form-group
              :state="errors"
              label="Photo Before"
              label-for="photo_before"
              invalid-feedback="Photo Before is required"
            >
              <b-img
                id="photoURL"
                :src="photo"
                fluid
                alt="photo before"
                class="mb-1"
                v-if="(hasImage === '') | null"
              />
            </b-form-group>
            <b-form-group
              :state="errors"
              label="Photo After"
              label-for="photo_after"
              invalid-feedback="Photo After is required"
            >
              <b-img
                id="photoURL2"
                :src="photo2"
                fluid
                alt="after photo"
                class="mb-1"
                v-if="form.status === 2"
              />
              <validation-provider
                #default="{ errors }"
                name="photo_after"
                rules="required"
                v-if="form.status === 1"
              >
                <image-uploader
                  id="photoAfter"
                  :preview="true"
                  :className="['fileinput', { 'fileinput--loaded': hasImage2 }]"
                  :debug="0"
                  :autoRotate="true"
                  accept="image/*"
                  doNotResize="['gif', 'svg']"
                  outputFormat="string"
                  @input="setImage2"
                ></image-uploader>
                <small class="text-danger">{{
                  errors[0] || errMessageImage
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BBadge,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Cleave from "vue-cleave-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    ImageUploader,
    Cleave,
    flatPickr,
    ToastificationContent,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BBadge,
    BImg,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        status: null,
        status_name: "",
        selectedItem: null,
        optionsItem: [],
        selectedLocation: null,
        optionsLocation: [],
        description: "",
        selectedCondition: null,
        optionsCondition: [
          { value: 1, text: "Normal" },
          { value: 2, text: "Medium" },
          { value: 3, text: "Bad" },
        ],
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      hasImage: "",
      image: "",
      photo: "",
      hasImage2: "",
      image2: "",
      photo2: "",
      errors: "",
      errMessage: "",
      errMessageImage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-warning",
        2: "light-success",
      };

      return (status) => statusColor[status];
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getDetails();
    this.getAssetItem();
    this.getLocation();
  },
  methods: {
    setImage: function (file) {
      this.hasImage = true;
      this.image = file;
    },
    setImage2: function (file) {
      this.hasImage2 = true;
      this.image2 = file;
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("asset/maintenance/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.status = response.data.data.status;
        this.form.status_name = response.data.data.status_name;
        this.form.selectedItem = {
          value: response.data.data.asset_id,
          text: response.data.data.asset_name,
        };
        this.form.selectedLocation = {
          value: response.data.data.location_id,
          text: response.data.data.location_name,
        };
        this.form.selectedCondition = {
          value: response.data.data.condition,
          text: response.data.data.condition_name,
        };
        this.form.description = response.data.data.description;
        const { baseUrl } = $themeConfig.app;
        this.photo = baseUrl;
        this.photo += "storage/maintenance/";
        this.photo += response.data.data.image_before;
        this.image = this.getBase64Image(document.getElementById("photoURL"));
        this.photo2 = baseUrl;
        this.photo2 += "storage/maintenance/";
        this.photo2 += response.data.data.image_after;
        this.image2 = this.getBase64Image(document.getElementById("photoURL2"));
      });
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      this.image = canvas.toDataURL("image/png");
      this.image += this.image.replace(/^data:image\/(png|jpg);base64,/, "");
      // console.log(this.image)
    },
    getAssetItem() {
      this.$http.get("asset/items").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          // console.log(datas[1].children.length === 0)
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsItem.push($data);
        }
        // console.log(this.form.optionsItem)
      });
    },
    getLocation() {
      this.$http.get("asset/locations").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          // console.log(datas[1].children.length === 0)
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsLocation.push($data);
        }
        // console.log(this.form.optionsLocation)
      });
    },
    validation() {
      if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else if (this.image2 === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Photo After field is required",
            variant: "warning",
          },
        });
      } else {
        this.updateAssetMaintenance();
      }
    },
    updateAssetMaintenance() {
      const id = this.$route.params.id;
      this.$http
        .post("asset/maintenance/" + id + "/update", {
          description: this.form.description,
          image_after: this.image2,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success update Asset Maintenance",
              variant: "success",
            },
          });
          location.href = "/asset/asset-maintenance";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style>
img.img-preview {
  width: 100%;
  margin-bottom: 15px;
}
</style>